<vp-tile-view-talk [document]="document" *ngIf="document.type==='talk'"></vp-tile-view-talk>
<vp-tile-view-mail [document]="document" *ngIf="document.type==='mail'"></vp-tile-view-mail>